import React, { useEffect } from 'react';
import { motion } from 'framer-motion';
import HeroSection from '../components/HeroSection';
import TherapyCard from '../components/TherapyCard';
import AudioPlayer from '../components/AudioPlayer';
import { therapyTypes, audioTracks } from '../data/mockData';

const HomePage = () => {
  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  return (
    <div>
      <HeroSection />
      
      {/* Services Section */}
      <section className="py-16 bg-white">
        <div className="section-container">
          <motion.div
            initial={{ opacity: 0, y: 20 }}
            whileInView={{ opacity: 1, y: 0 }}
            transition={{ duration: 0.6 }}
            viewport={{ once: true }}
            className="text-center mb-12"
          >
            <h2 className="text-3xl font-bold text-sharon-dark-green mb-4">השירותים שלי</h2>
            <p className="text-lg text-sharon-gray max-w-2xl mx-auto">
              אני מציעה מגוון שירותי טיפול המותאמים לצרכים השונים של המטופלים, בגישה מקצועית, אמפתית ומכבדת
            </p>
          </motion.div>

          <div className="grid grid-cols-1 md:grid-cols-3 gap-8">
            {therapyTypes.map((therapy) => (
              <TherapyCard
                key={therapy.id}
                title={therapy.title}
                description={therapy.description}
                imageSrc={therapy.imageSrc}
                link={therapy.link}
              />
            ))}
          </div>
        </div>
      </section>

      {/* About Section */}
      <section className="py-16 bg-sharon-light-green">
        <div className="section-container">
          <div className="flex flex-col md:flex-row items-center justify-between">
            <motion.div
              className="w-full md:w-1/2 mb-8 md:mb-0"
              initial={{ opacity: 0, x: -20 }}
              whileInView={{ opacity: 1, x: 0 }}
              transition={{ duration: 0.6 }}
              viewport={{ once: true }}
            >
              <h2 className="text-3xl font-bold text-sharon-dark-green mb-4">אודות</h2>
              <p className="text-lg text-sharon-gray mb-6">
                שמי שרון וייספלד, אני פסיכולוגית מומחית עם התמחות בטיפול משפחתי, זוגי ואישי. במשך למעלה מעשר שנים אני מלווה אנשים בתהליכי שינוי, צמיחה והתמודדות עם אתגרי החיים השונים.
              </p>
              <p className="text-lg text-sharon-gray mb-6">
                הגישה הטיפולית שלי משלבת אלמנטים מגישות טיפוליות שונות, ומותאמת באופן אישי לצרכים הייחודיים של כל מטופל ומטופלת.
              </p>
              <div className="mt-8">
                <a href="/about" className="sharon-btn">
                  קרא עוד עליי
                </a>
              </div>
            </motion.div>

            <motion.div
              className="w-full md:w-1/2 flex justify-center"
              initial={{ opacity: 0, x: 20 }}
              whileInView={{ opacity: 1, x: 0 }}
              transition={{ duration: 0.6 }}
              viewport={{ once: true }}
            >
              <div className="w-full max-w-md rounded-lg overflow-hidden shadow-lg">
                <img 
                  src="https://images.unsplash.com/photo-1551836022-aadb801c60ae?ixlib=rb-4.0.3&auto=format&fit=crop&w=800&q=80" 
                  alt="שרון וייספלד" 
                  className="w-full h-80 object-cover"
                />
              </div>
            </motion.div>
          </div>
        </div>
      </section>

      {/* Media Section */}
      <section className="py-16 bg-white">
        <div className="section-container">
          <motion.div
            initial={{ opacity: 0, y: 20 }}
            whileInView={{ opacity: 1, y: 0 }}
            transition={{ duration: 0.6 }}
            viewport={{ once: true }}
            className="text-center mb-12"
          >
            <h2 className="text-3xl font-bold text-sharon-dark-green mb-4">מדיה</h2>
            <p className="text-lg text-sharon-gray max-w-2xl mx-auto">
              הקשיבו להרצאות, מדיטציות ותרגילים שיסייעו לכם בתהליך הטיפולי
            </p>
          </motion.div>

          <div className="space-y-6">
            {audioTracks.map((track) => (
              <AudioPlayer
                key={track.id}
                title={track.title}
                description={track.description}
                audioSrc={track.audioSrc}
              />
            ))}
          </div>
        </div>
      </section>

      {/* Contact CTA Section */}
      <section className="py-16 bg-sharon-light-green">
        <div className="section-container text-center">
          <motion.div
            initial={{ opacity: 0, y: 20 }}
            whileInView={{ opacity: 1, y: 0 }}
            transition={{ duration: 0.6 }}
            viewport={{ once: true }}
          >
            <h2 className="text-3xl font-bold text-sharon-dark-green mb-4">צרו קשר</h2>
            <p className="text-lg text-sharon-gray max-w-2xl mx-auto mb-8">
              לקביעת פגישת היכרות או לכל שאלה, אל תהססו ליצור איתי קשר
            </p>
            <div className="flex flex-col sm:flex-row items-center justify-center space-y-4 sm:space-y-0 sm:space-x-4 sm:space-x-reverse">
              <a
                href="tel:+972526507776"
                className="sharon-btn text-lg px-6 py-2 rounded-md"
              >
                התקשרו עכשיו: 0526507776
              </a>
              <a
                href="mailto:sharon.weisfeld@gmail.com"
                className="text-sharon-dark-green hover:text-sharon-green transition-colors duration-300 text-lg"
              >
                sharon.weisfeld@gmail.com
              </a>
            </div>
          </motion.div>
        </div>
      </section>
    </div>
  );
};

export default HomePage;